import { ACTION, CATEGORY, evt, setUserForAnalytics } from "./analytics";

export function setAnalyticsSession({
  partnerId = "",
  privateMode = false,
  version = "",
  name = "",
}: {
  partnerId?: string;
  privateMode?: boolean;
  version?: string;
  name?: string;
}) {
  setUserForAnalytics(name, {}, null, privateMode);

  evt({
    category: CATEGORY.PATIENT_INIT,
    action: ACTION.SESSION_INIT,
    label: version,
    partnerId,
  });
}
